import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faUpload, faMobileAndroid, faSquare, faTimes, faPlus, faArrowToBottom,
  faExclamationTriangle, faChevronLeft, faChevronDown, faChevronUp, faClock, faCalendarDay, faMapMarkerAlt,
  faCalendarAlt, faAngleLeft, faAngleRight, faExclamationCircle, faUser, faUserFriends,
  faCreditCardBlank, faKeynote, faRectangleLandscape, faAlignLeft, faAlignCenter, faAlignRight,
  faArrowToTop, faGripLines, faBroadcastTower, faFont, faQuoteLeft, faNewspaper, faPortrait, faUserCircle,
  faQuestionCircle, faCheckCircle, faColumns, faCircleNotch, faBan, faBringForward, faSendBackward,
  faEuroSign, faHandPointRight, faPlay, faRetweet, faHeart, faPaste, faCheck, faGifts, faHatSanta, faAbacus,
  faChartBar, faHighlighter, faCog, faGripHorizontal, faDesktop, faTrash, faSave, faPen, faSignOutAlt, faSync,
  faTableRows, faClone, faLink, faDiceD20, faFileAlt
} from '@fortawesome/pro-regular-svg-icons'
import {
  faBadgeCheck
} from '@fortawesome/pro-solid-svg-icons'
import {
  faTwitter, faFacebook, faInstagram, faTwitch, faYoutube
} from '@fortawesome/free-brands-svg-icons'

library.add(
  faUpload, faMobileAndroid, faSquare, faTimes, faPlus, faArrowToBottom,
  faExclamationTriangle, faChevronLeft, faChevronDown, faChevronUp, faClock, faCalendarDay, faMapMarkerAlt,
  faCalendarAlt, faAngleLeft, faAngleRight, faExclamationCircle, faUser, faUserFriends,
  faCreditCardBlank, faKeynote, faRectangleLandscape, faAlignLeft, faAlignCenter, faAlignRight,
  faArrowToTop, faGripLines, faBroadcastTower, faFont, faQuoteLeft, faNewspaper, faPortrait, faUserCircle,
  faQuestionCircle, faCheckCircle, faColumns, faCircleNotch, faBan, faBringForward, faSendBackward,
  faEuroSign, faHandPointRight, faPlay, faTwitter, faRetweet, faHeart, faBadgeCheck, faPaste, faCheck,
  faGifts, faHatSanta, faChartBar, faHighlighter, faCog, faGripHorizontal, faFacebook, faInstagram, faTwitch,
  faYoutube, faDesktop, faTrash, faSave, faPen, faSignOutAlt, faSync, faTableRows, faClone, faLink, faDiceD20,
  faAbacus, faFileAlt
)
